<template>
  <div class="exchange-submit-form">
    <template v-if="receiveStatus === 'canReceive'">
      <receiver-info :avatar="receiver.avatar"
                     :name="receiver.name"
                     :desc="receiver.desc"
                     v-if="receiver"
      ></receiver-info>
      <verify-mobile @submitAction="handleSmsSubmit"
                     v-if="render.needMobile"
      ></verify-mobile>
      <submit-btn :receive-status="receiveStatus"
                  :receive-tips="render.receiveTips"
                  :submit-text="render.submitText"
                  :submit-btn-disabled="submitBtnDisabled"
                  :id="id"
                  :code="code"
                  :mobile="mobile"
                  :sms-code="smsCode"
                  :share-path="sharePath"
      ></submit-btn>
    </template>
    <template v-if="receiveStatus === 'disabled'">
      <submit-btn :receive-status="receiveStatus"
                  :receive-tips="render.receiveTips"
                  :submit-text="render.submitText"
                  :submit-btn-disabled="submitBtnDisabled"
                  :id="id"
                  :code="code"
                  :mobile="mobile"
                  :sms-code="smsCode"
                  :share-path="sharePath"
      ></submit-btn>
    </template>
  </div>
</template>

<script>
  import ReceiverInfo from '@/components/Exchange/ReceiverInfo';
  import VerifyMobile from '@/components/Exchange/VerifyMobile';
  import SubmitBtn from '@/pages/Receive/components/SubmitBtn';

  export default {
    name: 'CouponReceiveSubmitForm',
    components: {
      VerifyMobile,
      ReceiverInfo,
      SubmitBtn,
    },
    data() {
      return {
        submitText: '',
        mobile: '',
        smsCode: '',
      };
    },
    props: {
      receiveStatus: {
        type: String,
        required: true,
      },
      receiver: {
        type: Object,
        default() {
          return {};
        },
      },
      render: {
        type: Object,
        default() {
          return {};
        },
      },
      id: {
        type: [String, Number],
        required: true,
      },
      code: {
        type: [String, Number],
        required: true,
        default: '',
      },
      sharePath: {
        type: String,
      },
    },
    watch: {
      submitAction(val) {
        if (val) {
          this.handleSubmitText(this.submitAction);
        }
      },
      mobile(val) {
        if (val.length === 0) {
          if (!this.render.needMobile) return;
          this.submitBtnDisabled = true;
        }
      },
      smsCode(val) {
        if (val === '') {
          if (!this.render.needMobile) return;
          this.submitBtnDisabled = true;
        }
      },
    },
    computed: {
      submitBtnDisabled() {
        if (!this.render.needMobile) return false;
        return this.mobile.length === 0 && this.smsCode.length === 0;
      },
    },
    methods: {
      handleSmsSubmit(params) {
        this.mobile = params.phone;
        this.smsCode = params.smsCode;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .direct-buy-tips {
    display: block;
    color: @color-text-lighter;
    text-align: center;
    margin-bottom: @size-base;
    font-size: @font-size-base;
  }
</style>
